// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__zLePf","card":"Cards_card__2aZ32","infected":"Cards_infected__2Upcc","recovered":"Cards_recovered__2n4T5","deaths":"Cards_deaths__bh39Y"};